import { $t } from '@user-center/utils/i18n'

export type SassmallTranslationParams = Record<string, string | number>

/**
 * Translate SassMall-owned copy through the user-center locale registry.
 * Source-language keys deliberately mirror the legacy chinaKeys convention so
 * page migrations remain readable and duplicate wording resolves to one key.
 */
export function st(source: string, params?: SassmallTranslationParams): string {
  return $t(`sassmall.${source}`, params)
}
